import { Tooltip } from "antd";
import * as React from "react";
import { BlankLink } from "src/components/BlankLink/BlankLink";

import * as styles from "./RenderLinkAction.module.less";

type RenderLinkActionProps = {
  icon?: React.ReactNode;
  tooltip?: string;
  href: string;
};

export const RenderLinkAction: React.FC<RenderLinkActionProps> = ({
  icon,
  tooltip,
  href,
}) => (
  <Tooltip title={tooltip}>
    <span className={styles.tooltipTrigger}>
      <BlankLink className={styles.actionLink} href={href}>
        {icon}
      </BlankLink>
    </span>
  </Tooltip>
);
